import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
//Utils 
import { checkUserPermission } from '../../utils/CheckUserPermitions';
import { RenderIf } from '../../utils/RenderIf';

import ModalSetting from '../ModalSetting';
import ModalNotification from '../ModalNotification';
//Api 
import { MachinesFetchAPI } from '../../../api/Machines';

import ErrorAlert from '../../Alerts/ErrorAlert';

const NavBar = ({ setPageLoader, codeParthner }) => {
   //Params 
   const navigate = useNavigate();
   let { business_code, branchoffice_code } = useParams();
   let user = localStorage.getItem('user');
   let token = localStorage.getItem('x-access-machine-token');
   let branchoffice = localStorage.getItem('branchoffice');
   let user_token = localStorage.getItem('x-access-token');
   const [showModalSetting, setshowModalSetting] = useState(false)
   //Location page 
   const url_path = useLocation();
   if (localStorage.getItem("x-access-machine-token") == "") {
      let business = JSON.parse(localStorage.getItem("business"))
      //navigate(`/machines/login/`+business.code)
      window.location.href = '/machines/login/' + business.code;
      console.log("hello");
   }

   //console.log('user:', user)

   //We validate if the user is logged in
   if (user === null || user === undefined || user === '' || user === 'null') {
      user = {
         name: 'No registrado',
         img: 'https://www.pngitem.com/pimgs/m/30-307416_profile-icon-png-image-free-download-searchpng-employee.png'
      }
   } else {
      user = JSON.parse(localStorage.getItem('user'));
   }

   //We validate if the branch
   if (branchoffice !== null && branchoffice !== undefined && branchoffice !== '') {
      branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
   }

   //Function to logout of the payment post
   const signout = async () => {
      let machine_token = localStorage.getItem('x-access-machine-token');
      let machine = JSON.parse(localStorage.getItem('machine_original'));

      if (!machine || !machine.code) {
         ErrorAlert("No se encontró información de la máquina", "No se puede cerrar sesión correctamente", "error");
         return;
      }

      let liberada = false;
      let errorMsg = '';
      try {
         const response = await MachinesFetchAPI.updateMachineStatus(machine.code, false, machine_token);
         if (response.data && response.data.success === true) {
            liberada = true;
         } else {
            errorMsg = response.data && response.data.error ? response.data.error : 'No se pudo liberar la máquina.';
         }
      } catch (err) {
         errorMsg = err?.response?.data?.error || err?.message || 'Error de red al liberar la máquina.';
      }

      if (liberada) {
         localStorage.clear();
         navigate(`/machines/login/${business_code}`);
      } else {
         ErrorAlert("No se pudo liberar la máquina", errorMsg + "\nIntente nuevamente. Si el problema persiste, contacte a soporte.", "error");
      }
   }

   const handleReload = () => {
      setPageLoader(1)
      ErrorAlert("Datos actualizados con exito", "Menu actualizado", "success")
   }

   useEffect(() => {
      //We check the data on the local storage 
      if (!url_path.pathname.includes('preaccount') && (user === '' || user === null || user === undefined || token === '' || branchoffice === '' || token === null || branchoffice === null || token === undefined || branchoffice === undefined || user_token === 'undefined' || user_token === 'null' || user_token === '' || user_token === null || user_token === undefined)) {
         navigate(`/machines/login/${business_code}`);
      }
   }, []);

   const [isVisible, setIsVisible] = useState(false);
   const buttonRef = useRef(null);
   const toggleVisibility = () => {
      setIsVisible(!isVisible);
   };

   const calculateDropdownPosition = () => {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      return {
         top: buttonRect.top + buttonRect.height,
         left: buttonRect.left,
      };
   };

   return (
      <>



         {/* 
            <ModalNotification></ModalNotification> */}
         <div className='bg-transparent '>
            <Dropdown>
               <Dropdown.Toggle id="dropdown-autoclose-true"
                  className='p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary border-0'>

                  <i className="uil uil-user"></i>
                  {/* <span className='mx-1 menu-label'> Cajero:</span>
                        <strong className='user-name menu-label'>{user.name}</strong> */}

               </Dropdown.Toggle>
               <Dropdown.Menu className='dropdown-index'>

                  <Dropdown.Item className='m-0 p-0 border border-light' >
                     <span className="dropdown-item bg-body-tertiary p-2" >

                        <span className='mx-1'> Usuario:</span>
                        <strong className='user-name'>{user.name} {user.lastName}</strong>
                     </span>
                  </Dropdown.Item>

                  <Dropdown.Item className='m-0 p-0 text-center' >
                     <button className="btn p-2 bg-primary text-white" onClick={() => (handleReload())} >
                        <span className='mx-1'>
                           <i className="uil uil-refresh user-name fw-bold "></i>  Actualizar Menú</span>
                     </button>
                  </Dropdown.Item>



                  <Dropdown.Item >
                     <Link className="dropdown-item" to={`/payments/${business_code}/${branchoffice_code}`}>
                        <i className="uil uil-bill"></i>  Caja de Pago
                     </Link>
                  </Dropdown.Item>
                  
                  <RenderIf isTrue={checkUserPermission("daily_pos_user_report", user.permissions) !== -1}>
                     <Dropdown.Item>
                        <Link className="dropdown-item" to={`/payment/report/${business_code}/${branchoffice_code}`}>
                           <i className="uil uil-file-graph"></i>  Reportes
                        </Link>
                     </Dropdown.Item>
                  </RenderIf>

                  <RenderIf isTrue={checkUserPermission("pos_closure_user_report", user.permissions) !== -1}>
                     <Dropdown.Item>
                        <Link className="dropdown-item" to={`/payment/closures/${business_code}/${branchoffice_code}`}>
                           <i className="uil uil-clipboard"></i> Historial de cierres
                        </Link>
                     </Dropdown.Item>
                  </RenderIf>

                  <RenderIf isTrue={checkUserPermission("delivery_module", user.permissions) !== -1}>
                     <Dropdown.Item>
                        <Link className="dropdown-item" to={`/payment/${business_code}/${branchoffice_code}/delivery`}>
                           <i className="uil uil-location-arrow-alt"></i> Delivery
                        </Link>
                     </Dropdown.Item>
                  </RenderIf>
                  <Dropdown.Item className='menu-label' >
                     <ModalSetting setPageLoader={setPageLoader} codeParthner={codeParthner}></ModalSetting>
                  </Dropdown.Item>
                  <hr className='dv my-0' />
                  <Dropdown.Item onClick={() => signout()}>
                     <i className="uil uil-signout"></i>
                     <span  >  Cerrar Sesión </span>
                  </Dropdown.Item>
               </Dropdown.Menu>
            </Dropdown>
         </div>

      </>
   )
}

export default NavBar